import React, { useState, useEffect } from 'react';
import './style.css';
import Header_home from './Header_home';
import Footer from './Footer';
import Menu from './Menu';
import Prductslide from './Prductslide';
import axios from 'axios';
import Product_detail from './Product_detail';
import Product_sidebar from './Product_sidebar';
import { withRouter } from './withRouter';
import { useNavigate } from 'react-router-dom';
class Orderplace extends React.Component {

  constructor(props) {
    super(props);
    this.backtohome = this.backtohome.bind(this);
    this.state = {
        
      api_url: localStorage.getItem('api_url'),
      category_id: localStorage.getItem('category_id'),
      data: [],
      product: {},
      product_detail: [],
      category_detail: [],
      subcategory_detail: [],
      prescription: 'no',
      search: '',
      suc_cls: '',
      errors: {},
      openModal: false,
      pic: '',
      fileName: '',
      email: '',
      email1: '',
      password: '',
      loading: true, // Initialize loading state here
    };
  }



  componentDidMount() {
  }

  backtohome(){
    this.props.navigate('/Home');
  }

  render() {
    return (

      
      <div className="">
        {<Header_home />}
        
        <div className='order_place'>
            <br></br>
        <img className="order1_img" alt="Group" src={require('./img/order_place.png')} />
        <p className='pay_suc'>Your Payment is Successful!</p>
        <p className='pay_su'>Your Order Placed!</p>
        <p className='pay_su1'>Thankyou for your payment. An automated payment receipt will be sent to your registered email.</p>
        <p className='pay_su2' onClick={this.backtohome}>Back to Home</p>
        </div>
       
        {<Footer />}
      </div>
    );
  }
}

export default withRouter(Orderplace);
